define('models/conceptCampaign',["jQuery", "T1", "T1Model"], function ($, T1, T1Model) {
  T1.Models.ConceptCampaign = T1Model.extend({
    url: "campaigns/",
    fixture: "-campaign"
  });
  return T1.Models.ConceptCampaign;
});
